import type { DocumentKind } from "@/api/client";

export type ReferenceKind = Exclude<DocumentKind, "drawing_set">;

/** What an organization can teach from, the commonest first (ADR-0014). */
export const REFERENCE_KINDS: readonly { kind: ReferenceKind; label: string; hint: string }[] = [
  {
    kind: "prior_takeoff",
    label: "Past take-off",
    hint: "A finished job's drawings with the estimator's markup on them: a box and a code on each unit.",
  },
  {
    kind: "code_standard",
    label: "Code standard",
    hint: "The legend or catalog that says what each part of your unit codes means.",
  },
  {
    kind: "spec",
    label: "Specification",
    hint: "Project specifications for the glazing and curtain-wall systems.",
  },
  {
    kind: "shop_drawing",
    label: "Shop drawings",
    hint: "Your shop drawings for a job: unit details, sections, assemblies.",
  },
  {
    kind: "order_export",
    label: "Order or pricing export",
    hint: "What a take-off became downstream: order entry or pricing.",
  },
];

export function kindLabel(kind: DocumentKind): string {
  return REFERENCE_KINDS.find((k) => k.kind === kind)?.label ?? "Drawing set";
}

/** Kinds this app reads and learns from; any other is kept for reference. */
export const READ_KINDS: ReadonlySet<string> = new Set(["prior_takeoff", "code_standard"]);
